(function() {
  if (window.SusucarProductBuilderLoaded) return;
  window.SusucarProductBuilderLoaded = true;

  function addDeliveryDays(startDate, numberOfDays, skipWeekends) {
    var result = new Date(startDate.getTime());
    var addedDays = 0;

    while (addedDays < numberOfDays) {
      result.setDate(result.getDate() + 1);

      if (skipWeekends && (result.getDay() === 0 || result.getDay() === 6)) {
        continue;
      }

      addedDays += 1;
    }

    return result;
  }

  function formatDeliveryDate(date, locale, dateFormat) {
    var options = {
      month: dateFormat === 'long' ? 'long' : 'short',
      day: 'numeric'
    };

    if (dateFormat === 'long') options.weekday = 'long';
    if (date.getFullYear() !== new Date().getFullYear()) options.year = 'numeric';

    try {
      return new Intl.DateTimeFormat(locale || 'en-US', options).format(date);
    } catch (error) {
      return new Intl.DateTimeFormat('en-US', options).format(date);
    }
  }

  function initializeDeliveryEstimate(container) {
    if (container.dataset.deliveryInitialized === 'true') return;

    var output = container.querySelector('[data-delivery-dates]');
    var minimumDays = Math.max(0, parseInt(container.dataset.minDays, 10) || 0);
    var maximumDays = Math.max(minimumDays, parseInt(container.dataset.maxDays, 10) || minimumDays);
    var skipWeekends = container.dataset.skipWeekends === 'true';
    var dateFormat = container.dataset.dateFormat || 'long';
    var locale = container.dataset.locale || 'en-US';
    var today = new Date();

    today.setHours(0, 0, 0, 0);

    var earliestDate = addDeliveryDays(today, minimumDays, skipWeekends);
    var latestDate = addDeliveryDays(today, maximumDays, skipWeekends);
    var earliestText = formatDeliveryDate(earliestDate, locale, dateFormat);
    var latestText = formatDeliveryDate(latestDate, locale, dateFormat);

    if (output) {
      output.textContent = earliestText === latestText ? earliestText : earliestText + ' - ' + latestText;
    }

    container.dataset.deliveryInitialized = 'true';
  }

  function getMobileStickyOffset() {
    var value = window.getComputedStyle(document.documentElement)
      .getPropertyValue('--susucar-mobile-sticky-header-offset');
    var parsedValue = parseFloat(value);

    return Number.isFinite(parsedValue) ? parsedValue : 94;
  }

  function centerProductNavControl(control) {
    var navigation = control.parentElement;

    if (!navigation) return;

    var left = control.offsetLeft - (navigation.clientWidth - control.offsetWidth) / 2;
    navigation.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  function setActiveProductNav(controls, activeControl, shouldCenter) {
    controls.forEach(function(control) {
      var isActive = control === activeControl;
      control.classList.toggle('active', isActive);

      if (isActive) {
        control.setAttribute('aria-current', 'location');
      } else {
        control.removeAttribute('aria-current');
      }
    });

    if (shouldCenter && activeControl) centerProductNavControl(activeControl);
  }

  function scrollToProductPanel(container, controls, control) {
    var target = container.querySelector(control.dataset.target);
    var navigation = container.querySelector('.product_tab-contorls');

    if (!target) return;

    var navigationHeight = navigation ? navigation.offsetHeight : 0;
    var targetTop = window.scrollY + target.getBoundingClientRect().top;
    var destination = Math.max(0, targetTop - getMobileStickyOffset() - navigationHeight - 8);

    setActiveProductNav(controls, control, true);
    window.scrollTo({ top: destination, behavior: 'smooth' });
  }

  function initializeProductTabs(container) {
    if (container.dataset.tabsEnhanced === 'true') return;

    var controls = Array.prototype.slice.call(container.querySelectorAll('.js-tab-control'));
    var navigation = container.querySelector('.product_tab-contorls');
    var mobileQuery = window.matchMedia('(max-width: 767px)');

    if (!controls.length || !navigation) return;

    var abortController = new AbortController();
    var frameRequested = false;

    function updateActiveControl() {
      frameRequested = false;
      if (!mobileQuery.matches) return;

      var threshold = getMobileStickyOffset() + navigation.offsetHeight + 18;
      var activeControl = controls[0];

      controls.forEach(function(control) {
        var target = container.querySelector(control.dataset.target);
        if (target && target.getBoundingClientRect().top <= threshold) activeControl = control;
      });

      setActiveProductNav(controls, activeControl, false);
    }

    function requestActiveControlUpdate() {
      if (frameRequested) return;
      frameRequested = true;
      window.requestAnimationFrame(updateActiveControl);
    }

    controls.forEach(function(control, index) {
      var target = container.querySelector(control.dataset.target);
      var controlId = 'susucar-anchor-' + container.dataset.sectionId + '-' + index;

      if (!target) return;

      control.id = controlId;
      control.setAttribute('role', 'link');
      control.setAttribute('aria-controls', target.id);
      control.tabIndex = 0;
      target.setAttribute('role', 'region');
      target.setAttribute('aria-labelledby', controlId);

      control.addEventListener('click', function() {
        if (mobileQuery.matches) scrollToProductPanel(container, controls, control);
      }, { signal: abortController.signal });

      control.addEventListener('keydown', function(event) {
        var nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % controls.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + controls.length) % controls.length;

        if (typeof nextIndex === 'number') {
          event.preventDefault();
          controls[nextIndex].focus();
          return;
        }

        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        if (mobileQuery.matches) scrollToProductPanel(container, controls, control);
      }, { signal: abortController.signal });
    });

    window.addEventListener('scroll', requestActiveControlUpdate, {
      passive: true,
      signal: abortController.signal
    });
    window.addEventListener('resize', requestActiveControlUpdate, {
      passive: true,
      signal: abortController.signal
    });
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.target === container || event.target.contains(container)) abortController.abort();
    }, { signal: abortController.signal });

    if (!container.querySelector('.js-tab-control.active')) controls[0].classList.add('active');
    requestActiveControlUpdate();
    container.dataset.tabsEnhanced = 'true';
  }

  function initializeProductAccordion(container) {
    if (container.dataset.productAccordionInitialized === 'true') return;

    var items = Array.prototype.slice.call(container.querySelectorAll('[data-product-spec-accordion-item]'));

    items.forEach(function(item) {
      item.addEventListener('toggle', function() {
        if (!item.open) return;

        items.forEach(function(otherItem) {
          if (otherItem !== item) otherItem.open = false;
        });
      });
    });

    container.dataset.productAccordionInitialized = 'true';
  }

  function parseStructuredLine(rawLine) {
    var line = rawLine.trim();
    var separatorIndex = line.search(/[:\uFF1A]/);

    if (!line || separatorIndex <= 0 || separatorIndex > 80) return null;

    var label = line.slice(0, separatorIndex).replace(/^[-*]\s*/, '').trim();
    var value = line.slice(separatorIndex + 1).trim();

    return label && value ? [label, value] : null;
  }

  function getStructuredLines(node) {
    var clone = node.cloneNode(true);

    if (clone.nodeType === 3) {
      return clone.textContent.split(/\r?\n/).map(function(line) {
        return line.trim();
      }).filter(Boolean);
    }

    clone.querySelectorAll('br').forEach(function(element) {
      element.replaceWith(document.createTextNode('\n'));
    });
    clone.querySelectorAll('p, li, div').forEach(function(element) {
      element.appendChild(document.createTextNode('\n'));
    });

    return clone.textContent.split(/\r?\n/).map(function(line) {
      return line.trim();
    }).filter(Boolean);
  }

  function createSpecificationTable(rows) {
    var table = document.createElement('table');
    var body = document.createElement('tbody');
    table.className = 'susucar-metafield-table__table';

    rows.forEach(function(row) {
      var tableRow = document.createElement('tr');
      var label = document.createElement('th');
      var value = document.createElement('td');

      label.scope = 'row';
      label.textContent = row[0];
      value.textContent = row[1];
      tableRow.appendChild(label);
      tableRow.appendChild(value);
      body.appendChild(tableRow);
    });

    table.appendChild(body);
    return table;
  }

  function initializeStructuredContent(container) {
    if (container.dataset.structuredContentInitialized === 'true') return;

    var output = document.createDocumentFragment();
    var pendingRows = [];
    var foundRows = false;

    function flushRows() {
      if (!pendingRows.length) return;

      output.appendChild(createSpecificationTable(pendingRows));
      pendingRows = [];
    }

    Array.prototype.slice.call(container.childNodes).forEach(function(node) {
      if (node.nodeType === 1 && /^H[1-6]$/.test(node.tagName)) {
        flushRows();
        output.appendChild(node.cloneNode(true));
        return;
      }

      if (node.nodeType === 3 && !node.textContent.trim()) return;

      var lines = getStructuredLines(node);
      var parsedLines = lines.map(function(line) {
        return { text: line, row: parseStructuredLine(line) };
      });
      var hasRows = parsedLines.some(function(item) {
        return item.row;
      });

      if (!hasRows) {
        flushRows();
        output.appendChild(node.cloneNode(true));
        return;
      }

      parsedLines.forEach(function(item) {
        if (item.row) {
          pendingRows.push(item.row);
          foundRows = true;
          return;
        }

        flushRows();
        var paragraph = document.createElement('p');
        paragraph.textContent = item.text;
        output.appendChild(paragraph);
      });
    });

    flushRows();

    if (foundRows) container.replaceChildren(output);
    container.dataset.structuredContentInitialized = 'true';
  }

  function initializeProductFaq(container) {
    if (container.dataset.faqInitialized === 'true') return;

    var source = container.querySelector('[data-faq-source]');
    var headings = source ? Array.prototype.filter.call(source.children, function(element) {
      return /^H[2-6]$/.test(element.tagName);
    }) : [];

    if (!source || !headings.length) {
      container.dataset.faqInitialized = 'true';
      return;
    }

    var list = document.createElement('div');
    list.className = 'product-page-faq__list';

    headings.forEach(function(heading, index) {
      var details = document.createElement('details');
      var summary = document.createElement('summary');
      var answer = document.createElement('div');
      var node = heading.nextSibling;

      details.className = 'product-page-faq__item';
      summary.className = 'product-page-faq__question';
      answer.className = 'product-page-faq__answer';
      summary.textContent = heading.textContent.trim();

      while (node && !(node.nodeType === 1 && /^H[2-6]$/.test(node.tagName))) {
        answer.appendChild(node.cloneNode(true));
        node = node.nextSibling;
      }

      if (index === 0 && container.dataset.openFirst === 'true') details.open = true;
      details.appendChild(summary);
      details.appendChild(answer);
      list.appendChild(details);
    });

    source.hidden = true;
    source.insertAdjacentElement('afterend', list);
    container.dataset.faqInitialized = 'true';
  }

  function copyText(value) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(value);
    }

    return new Promise(function(resolve, reject) {
      var textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();

      try {
        document.execCommand('copy');
        resolve();
      } catch (error) {
        reject(error);
      } finally {
        textarea.remove();
      }
    });
  }

  function initializeCopyProductUrl(button) {
    if (button.dataset.copyInitialized === 'true') return;

    button.addEventListener('click', function() {
      var label = button.querySelector('span');
      var defaultLabel = button.dataset.copyLabel || 'Copy link';
      var copiedLabel = button.dataset.copiedLabel || 'Copied';

      copyText(button.dataset.copyProductUrl || window.location.href).then(function() {
        if (label) label.textContent = copiedLabel;
        button.setAttribute('aria-label', copiedLabel);

        window.setTimeout(function() {
          if (label) label.textContent = defaultLabel;
          button.setAttribute('aria-label', defaultLabel);
        }, 2000);
      });
    });

    button.dataset.copyInitialized = 'true';
  }

  function initializeNativeShare(button) {
    if (button.dataset.nativeShareInitialized === 'true') return;

    if (typeof navigator.share !== 'function') {
      var listItem = button.closest('li');
      if (listItem) listItem.hidden = true;
      button.dataset.nativeShareInitialized = 'true';
      return;
    }

    button.addEventListener('click', function() {
      navigator.share({
        title: button.dataset.shareTitle || document.title,
        url: button.dataset.shareUrl || window.location.href
      }).catch(function() {});
    });

    button.dataset.nativeShareInitialized = 'true';
  }

  function isVisible(element) {
    if (!element || !element.isConnected) return false;

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function findButtonInRoot(root) {
    if (!root || !root.querySelectorAll) return null;

    var buttons = Array.prototype.slice.call(root.querySelectorAll('button, [role="button"]'));
    var labelPattern = /^(chat|assistance|contact|help|support|live chat|message us|need help\??)$/i;

    for (var index = 0; index < buttons.length; index += 1) {
      var button = buttons[index];
      var label = (button.getAttribute('aria-label') || button.getAttribute('title') || button.textContent || '').trim();

      if (!button.hasAttribute('data-shopify-inbox-trigger') && labelPattern.test(label) && isVisible(button)) {
        return button;
      }
    }

    var elements = root.querySelectorAll('*');
    for (var elementIndex = 0; elementIndex < elements.length; elementIndex += 1) {
      if (elements[elementIndex].shadowRoot) {
        var shadowButton = findButtonInRoot(elements[elementIndex].shadowRoot);
        if (shadowButton) return shadowButton;
      }
    }

    return null;
  }

  function findShopifyInboxLauncher() {
    var containers = document.querySelectorAll([
      'shopify-chat',
      '#ShopifyChat',
      '[id*="shopify-chat" i]',
      '[class*="shopify-chat" i]',
      '[data-shopify-inbox]'
    ].join(','));

    for (var index = 0; index < containers.length; index += 1) {
      var container = containers[index];
      var launcher = findButtonInRoot(container.shadowRoot || container);
      if (launcher) return launcher;
    }

    var fixedButtons = Array.prototype.slice.call(document.querySelectorAll('button, [role="button"]'));
    var labelPattern = /^(chat|assistance|contact|help|support|live chat|message us|need help\??)$/i;

    return fixedButtons.find(function(button) {
      var label = (button.getAttribute('aria-label') || button.getAttribute('title') || button.textContent || '').trim();
      var styles = window.getComputedStyle(button);
      return !button.hasAttribute('data-shopify-inbox-trigger') && styles.position === 'fixed' && labelPattern.test(label) && isVisible(button);
    }) || null;
  }

  function initializeShopifyInboxTrigger(button) {
    if (button.dataset.inboxInitialized === 'true') return;

    button.addEventListener('click', function() {
      var popup = button.closest('.susucar-product-popup');
      var status = popup ? popup.querySelector('[data-shopify-inbox-status]') : null;
      var attempts = 0;
      var event = new CustomEvent('susucar:shopify-inbox:open', { bubbles: true, cancelable: true });

      if (status) {
        status.hidden = true;
        status.textContent = '';
      }

      if (!document.dispatchEvent(event)) {
        if (window.Fancybox && typeof window.Fancybox.close === 'function') window.Fancybox.close();
        return;
      }

      function openLauncher() {
        var launcher = findShopifyInboxLauncher();
        attempts += 1;

        if (launcher) {
          if (window.Fancybox && typeof window.Fancybox.close === 'function') window.Fancybox.close();
          window.setTimeout(function() {
            launcher.focus();
            launcher.click();
          }, 180);
          return;
        }

        if (attempts < 5) {
          window.setTimeout(openLauncher, 250);
          return;
        }

        if (status) {
          status.textContent = button.dataset.inboxUnavailable || 'Live chat is currently unavailable.';
          status.hidden = false;
        }
      }

      openLauncher();
    });

    button.dataset.inboxInitialized = 'true';
  }

  function reopenSuccessfulSupportForm(scope) {
    var success = (scope || document).querySelector('[data-support-form-success]');
    if (!success) return;

    var popup = success.closest('.susucar-product-popup');
    if (!popup) return;

    var trigger = document.querySelector('[data-src="#' + popup.id + '"]');
    if (trigger) window.setTimeout(function() { trigger.click(); }, 250);
  }

  function initializeProductBuilder(scope) {
    (scope || document).querySelectorAll('[data-delivery-estimate]').forEach(initializeDeliveryEstimate);
    (scope || document).querySelectorAll('[data-susucar-tabs]').forEach(initializeProductTabs);
    (scope || document).querySelectorAll('[data-product-spec-accordion]').forEach(initializeProductAccordion);
    (scope || document).querySelectorAll('[data-structured-content]').forEach(initializeStructuredContent);
    (scope || document).querySelectorAll('[data-product-faq]').forEach(initializeProductFaq);
    (scope || document).querySelectorAll('[data-copy-product-url]').forEach(initializeCopyProductUrl);
    (scope || document).querySelectorAll('[data-native-share]').forEach(initializeNativeShare);
    (scope || document).querySelectorAll('[data-shopify-inbox-trigger]').forEach(initializeShopifyInboxTrigger);
    reopenSuccessfulSupportForm(scope || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeProductBuilder(document);
    });
  } else {
    initializeProductBuilder(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeProductBuilder(event.target);
  });
})();
